import axios from "axios";
import jwtDefaultConfig from "./jwtDefaultConfig";
import { toast } from "react-toastify";

export default class JwtService {
  // ** jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig };

  // ** For Refreshing Token
  isAlreadyFetchingAccessToken = false;

  // ** For Refreshing Token
  subscribers = [];

  constructor(jwtOverrideConfig) {
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig };

    // ** Request Interceptor
    axios.interceptors.request.use(
      (config) => {
        // ** Get token from localStorage
        const accessToken = this.getToken();

        // ** If token is present add it to request's Authorization Header
        if (accessToken) {
          // ** eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `${this.jwtConfig.tokenType
            } ${accessToken.replaceAll('"', "")}`;
          config.headers["x-country-code"] = localStorage.getItem("x-country-code");
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    // ** Add request/response interceptor
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          toast.error(error.response.data.error.message, {
            onClose: () => {
              window.location.href = "/login";
            },
            autoClose: 5000,
            icon: true,
            hideProgressBar: false,
            closeButton: true,
          });
          localStorage.clear();
        } else if (error.response && error.response.status === 403) {
          if (error.response.data.error.code === 'password_change_required') {
            toast.error(error.response.data.error.message, {
              onClose: () => {
                window.location.href = "/change-password";
              },
              autoClose: 2000,
              icon: true,
              hideProgressBar: false,
              closeButton: true,
            });
          } else {
            toast.error(error.response.data.error.message, {
              icon: true,
              hideProgressBar: false,
              closeButton: true,
            });
          }
        }
        return Promise.reject(error);
      }
    );
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter((callback) =>
      callback(accessToken)
    );
  }

  addSubscriber(callback) {
    this.subscribers.push(callback);
  }

  getToken() {
    return localStorage.getItem(this.jwtConfig.storageTokenKeyName);
  }

  getRefreshToken() {
    return localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName);
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value);
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value);
  }

  login(...args) {
    return axios.post(this.jwtConfig.loginEndpoint, ...args);
  }

  register(...args) {
    return axios.post(this.jwtConfig.registerEndpoint, ...args);
  }
  votp(...args) {
    return axios.post(this.jwtConfig.votpEndpoint, ...args);
  }

  refreshToken() {
    return axios.post(this.jwtConfig.refreshEndpoint, {
      refreshToken: this.getRefreshToken(),
    });
  }
}
